import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconHistory",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, l, _, f, a) {
  return d(), n("svg", {
    "aria-label": l.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--history"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "History",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    i("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6 3a.5.5 0 0 1 .5.5v2.191l1.724.862a.5.5 0 0 1-.447.894l-2-1A.5.5 0 0 1 5.5 6V3.5A.5.5 0 0 1 6 3Z",
      fill: "currentColor"
    }, null, -1),
    i("path", {
      d: "M8.837 1.89a5 5 0 0 0-6.17.387l-.667.6V1.5a.5.5 0 1 0-1 0V4a.5.5 0 0 0 .5.5H4a.5.5 0 1 0 0-1H2.803l.531-.478a4 4 0 1 1-1.312 3.423.5.5 0 1 0-.994.11A5 5 0 1 0 8.837 1.89Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const b = /* @__PURE__ */ s(c, [["render", m]]);
export {
  b as default
};
//# sourceMappingURL=history.js.map
